'use client';
import React from 'react';
import { useSelector } from 'react-redux';
import Modal from '@/components/molecules/modal';
import Link from 'next/link';

interface IProps {
  open: boolean;
  onCancel: ()=>void;
  title: string
}

const PermissionModal: React.FC<IProps> = ({ open, onCancel, title }) => {
  const userData = useSelector((state: any) => state.userData);
  return (
    <Modal
      open={open}
      footer={false}
      width={500}
      centered
      closable={true}
      className="o-report-modal"
      onCancel={onCancel}
      maskClosable={false}
    >
      <div className="o-report-modal_title">{title}</div>
      <div className="o-report-modal_content">
        {userData?.user
          ? 'Chức năng này yêu cầu quyền truy cập cao hơn. Hãy nâng cấp gói dịch vụ của bạn để trải nghiệm đầy đủ tính năng và hỗ trợ chuyên nghiệp nhất!'
          : 'Dường như bạn chưa đăng nhập. Để sử dụng dịch vụ này, vui lòng đăng nhập hoặc tạo tài khoản ngay bây giờ. Chỉ mất vài giây để bắt đầu trải nghiệm!'}
      </div>
      <div className="o-report-modal_action">
        <Link
          href={userData?.user ? '/cac-goi-du-lieu' : `/xac-thuc-nguoi-dung`}
        >
          {userData?.user ? 'Nâng cấp gói' : 'Đăng nhập'}
        </Link>
      </div>
    </Modal>
  );
};

export default PermissionModal;
